/* ============================================================================
 * Movatic WMS — Frontend | CesarFilho 932048016
 * Componente: IssueAttachmentsModal
 * ----------------------------------------------------------------------------
 * Botão "Anexos" que abre um modal contendo o IssueAttachmentsCard.
 * - Props: issueId, count? (attachments_count da lista), buttonClassName?
 * - Alto contraste e fechamento por ESC / overlay.
 * ========================================================================== */

import React, { useEffect, useState } from "react";
import IssueAttachmentsCard from "./IssueAttachmentsCard";

export default function IssueAttachmentsModal({
    issueId,
    count,
    buttonClassName = "btn btn-xs",
    label = "Anexos",
}: {
    issueId: number;
    count?: number;
    buttonClassName?: string;
    label?: string;
}) {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (!open) return;
        const onKey = (e: KeyboardEvent) => {
            if (e.key === "Escape") setOpen(false);
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [open]);

    return (
        <>
            <button
                type="button"
                className={buttonClassName}
                onClick={() => setOpen(true)}
                title="Ver/Anexar arquivos"
            >
                {label}
                {typeof count === "number" && (
                    <span className="ml-1 inline-block rounded bg-neutral-800 px-1 text-[10px]">
                        {count}
                    </span>
                )}
            </button>

            {open && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center">
                    <div
                        className="absolute inset-0 bg-black/60"
                        onClick={() => setOpen(false)}
                        aria-hidden="true"
                    />
                    <div className="relative z-[101] w-full max-w-2xl rounded-xl border border-neutral-800 bg-neutral-900 text-neutral-100 shadow-2xl">
                        <div className="flex items-center justify-between border-b border-neutral-800 px-4 py-3">
                            <div className="text-sm font-semibold">
                                {label} • Issue #{issueId}
                            </div>
                            <button
                                type="button"
                                className="btn btn-xs btn-ghost"
                                onClick={() => setOpen(false)}
                                aria-label="Fechar"
                            >
                                Fechar
                            </button>
                        </div>

                        <div className="p-4">
                            <IssueAttachmentsCard
                                issueId={issueId}
                                count={count}
                                className="border-0 bg-transparent p-0"
                            />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
